import { Chip } from '@pets-ui/Chip/Chip'
import { BrandChip } from '../../../../components/BrandChip/BrandChip'
import { ScrollableList } from '../../../../components/ScrollableList/ScrollableList'
import { BrandCategory, brandImageMap, type BrandInfo } from '../../constants'
import { useStmBrandStore } from '../../hooks'

interface BrandSelectorProps {
  allowDeselect?: boolean
}

export const BrandSelector = (props: BrandSelectorProps) => {
  const { allowDeselect = false } = props
  const { currentBrand, setBrand, brands } = useStmBrandStore()

  const handleSelectBrand = (brand: BrandInfo) => {
    if (allowDeselect && brand.campaignCode === currentBrand?.campaignCode) {
      setBrand(null)
    }
    else {
      setBrand(brand.campaignCode)
    }
  }

  return (
    <ScrollableList>
      {brands.map(brand => (
        <BrandChip
          key={brand.campaignCode}
          imageSrc={brandImageMap[brand.projectCode]?.badge}
          imageAlt={brand.projectCode}
          selected={brand.campaignCode === currentBrand?.campaignCode}
          badge={brand.category === BrandCategory.HUMAN && (
            <Chip position="absolute" left={-1} top={-1} size="xSmall" variant="square" color="green">人食品牌</Chip>
          )}
          onClick={() => handleSelectBrand(brand)}
        />
      ))}
    </ScrollableList>
  )
}
